import { Component, computed, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { CloseComponent } from '../shared/components';
import { ProgressFacade } from '@app/store/progress';
import { courseRouteSegments } from '@app/shared/utils';
import { BtnComponent } from '../../btn/btn.component';
import { LoaderComponent } from '../../loader/loader.component';

@Component({
    selector: 'app-course-completed',
    imports: [TranslatePipe, BtnComponent, CloseComponent, RouterLink, LoaderComponent],
    templateUrl: './course-completed.component.html',
    styleUrl: './course-completed.component.css',
})
export class CourseCompletedComponent {
    private readonly progressFacade = inject(ProgressFacade);
    private readonly route = inject(ActivatedRoute);

    private readonly queryParams = toSignal(this.route.queryParams);

    readonly courseId = computed(() => this.queryParams()?.['courseId'] ?? '');
    readonly pathId = computed(() => this.queryParams()?.['pathId'] ?? '');
    readonly nextCourseId = computed(() => this.queryParams()?.['nextCourseId'] ?? null);

    readonly allCoursesLink = ['/', { outlets: { primary: ['all-courses'], modal: null } }];

    readonly nextCourseLink = computed(() => {
        const nextCourseId = this.nextCourseId();
        if (!nextCourseId) return null;

        return ['/', { outlets: { primary: courseRouteSegments(this.pathId() || null, nextCourseId), modal: null } }];
    });

    readonly isFullyCompleted = computed(() => {
        const progress = this.progressFacade.courseProgress(this.courseId())();
        return progress !== null && progress.lessonsProgress === 100;
    });

    readonly courseProgressLoading = computed(() => {
        const courseId = this.courseId();
        if (!courseId) return false;

        return this.progressFacade.courseProgressLoading(courseId)() ?? false;
    });

    constructor() {
        effect(() => {
            const courseId = this.courseId();
            if (!courseId) return;

            this.progressFacade.getCourseProgress(courseId);
        });
    }
}
